import _objectSpread from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
export var definitions = {
  cpf: {
    filter: function filter(char) {
      return !Number.isNaN(Number.parseInt(char, 10));
    },
    tokens: [{
      value: '.',
      indexes: [3, 7]
    }, {
      value: '-',
      indexes: [11]
    }],
    length: 14
  },
  cnpj: {
    filter: function filter(char) {
      return !Number.isNaN(Number.parseInt(char, 10));
    },
    tokens: [{
      value: '.',
      indexes: [2, 6]
    }, {
      value: '/',
      indexes: [10]
    }, {
      value: '-',
      indexes: [15]
    }],
    length: 18
  },
  cep: {
    filter: function filter(char) {
      return !Number.isNaN(Number.parseInt(char, 10));
    },
    tokens: [{
      value: '-',
      indexes: [5]
    }],
    length: 9
  },
  susep: {
    filter: function filter(char) {
      return !Number.isNaN(Number.parseInt(char, 10));
    },
    tokens: [{
      value: '.',
      indexes: [5]
    }, {
      value: '/',
      indexes: [12]
    }, {
      value: '-',
      indexes: [17]
    }],
    length: 20
  },
  telephone: {
    filter: function filter(char) {
      return !Number.isNaN(Number.parseInt(char, 10));
    },
    tokens: [{
      value: '(',
      indexes: [0]
    }, {
      value: ') ',
      indexes: [3]
    }, {
      value: '-',
      indexes: [-4]
    }],
    length: 15
  },
  currency: {
    filter: function filter(char) {
      return !Number.isNaN(Number.parseInt(char, 10));
    },
    tokens: [{
      value: '$ ',
      indexes: [0]
    }, {
      value: '.',
      indexes: [-2]
    }]
  },
  date: {
    filter: function filter(char) {
      return !Number.isNaN(Number.parseInt(char, 10));
    },
    tokens: [{
      value: '/',
      indexes: [2, 5]
    }],
    length: 10
  }
};

var valueToString = function valueToString(value) {
  return typeof value !== 'string' ? String(value) : value;
};

var hasNoPolarity = function hasNoPolarity(value) {
  return !String(value).includes('-') && !String(value).includes('+');
};

var isNegative = function isNegative(value) {
  return Number(value < 0);
};

var isInvalidNegative = function isInvalidNegative(original, formatted) {
  return isNegative(original) && hasNoPolarity(formatted);
};

var shouldAdjustPolarity = function shouldAdjustPolarity(value, formattedValue) {
  return isInvalidNegative(value, formattedValue);
};

var getAdjustedPreffix = function getAdjustedPreffix(currencyPreffix) {
  return currencyPreffix.includes('-') ? currencyPreffix : "".concat(currencyPreffix, " -");
};

export var format = function format() {
  var parsedValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var definition = arguments.length > 1 ? arguments[1] : undefined;
  var valueAsString = valueToString(parsedValue);
  return valueAsString.split('').filter(definition.filter).reduce(function (accumulator, currentValue, index, array) {
    var currentIndex = accumulator.length;
    var token = definition.tokens.find(function (t) {
      return t.indexes.some(function (tokenIndex) {
        return tokenIndex >= 0 ? tokenIndex === currentIndex : tokenIndex === index - array.length;
      });
    });

    if (token && array[index] !== token.value) {
      return "".concat(accumulator).concat(token.value).concat(currentValue);
    }

    return "".concat(accumulator).concat(currentValue);
  }, '').substring(0, definition.length);
};
export var formatCpfCnpj = function formatCpfCnpj(value) {
  var valueAsString = valueToString(value) || '';
  var onlyDigits = valueAsString.replace(/\D/g, '') || '';
  var charArray = onlyDigits.split('');
  return charArray.length < 12 ? format(value, definitions.cpf) : format(value, definitions.cnpj);
};
export var parse = function parse() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var definition = arguments.length > 1 ? arguments[1] : undefined;
  return definition.tokens.reduce(function (accumulator, token) {
    return token.indexes.reduce(function (acc) {
      return acc.replace(token.value, '');
    }, accumulator);
  }, value);
};
export var parseCpfCnpj = function parseCpfCnpj(value) {
  var valueAsString = valueToString(value) || '';
  var onlyDigits = valueAsString.replace(/\D/g, '') || '';
  var charArray = onlyDigits.split('');
  var definition = charArray.length < 12 ? definitions.cpf : definitions.cnpj;
  return definition.tokens.reduce(function (accumulator, token) {
    return token.indexes.reduce(function (acc) {
      return acc.replace(token.value, '');
    }, accumulator);
  }, value);
};
export var escapeRegExp = function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
export var formatCpf = function formatCpf(value) {
  return format(value, definitions.cpf);
};
export var parseCpf = function parseCpf(value) {
  return parse(value, definitions.cpf);
};
export var formatCnpj = function formatCnpj(value) {
  return format(value, definitions.cnpj);
};
export var parseCnpj = function parseCnpj(value) {
  return parse(value, definitions.cnpj);
};
export var formatCep = function formatCep(value) {
  return format(value, definitions.cep);
};
export var parseCep = function parseCep(value) {
  return parse(value, definitions.cep);
};
export var formatSusep = function formatSusep(value) {
  return format(value, definitions.susep);
};
export var parseSusep = function parseSusep(value) {
  return parse(value, definitions.susep);
};
export var formatTel = function formatTel(value) {
  return format(value, definitions.telephone);
};
export var parseTel = function parseTel(value) {
  return parse(value, definitions.telephone);
};
export var formatDate = function formatDate(value) {
  if (value && /^\d{1}\/\d{2}\/\d{4}$/.test(value)) {
    return "0".concat(value);
  }

  return format(value, definitions.date);
};
export var parseDate = function parseDate(value) {
  return parse(value, definitions.date);
};
export var parseCurrency = function parseCurrency() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$cents = _ref.cents,
      cents = _ref$cents === void 0 ? ',' : _ref$cents;

  return Number(String(value).trim().replace(new RegExp("\\".concat(cents), 'g'), '.').replace(new RegExp("\\.(?=.+\\.)", 'g'), '').replace(new RegExp("[^\\d\\.]", 'g'), ''));
};
export var formatCurrency = function formatCurrency(value) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$currency = _ref2.currency,
      currencyPreffix = _ref2$currency === void 0 ? 'R$ ' : _ref2$currency,
      _ref2$thousands = _ref2.thousands,
      thousands = _ref2$thousands === void 0 ? '.' : _ref2$thousands,
      _ref2$cents = _ref2.cents,
      cents = _ref2$cents === void 0 ? ',' : _ref2$cents;

  if (Number.isNaN(parseInt(parseCurrency(value), 10))) {
    return '';
  }

  var parsedValue = parseCurrency(value).toFixed(2).replace('.', cents);
  var preffix = shouldAdjustPolarity(value, parsedValue) ? getAdjustedPreffix(currencyPreffix) : currencyPreffix;
  return format(parsedValue, _objectSpread(_objectSpread({}, definitions.currency), {}, {
    tokens: [{
      value: preffix,
      indexes: [0]
    }, {
      value: cents,
      indexes: [-2]
    }, {
      value: thousands,
      indexes: [-5, -8, -11, -14, -17, -20, -23]
    }]
  }));
};
export var currency2Number = function currency2Number(value) {
  var numbers = value.split(/\s/).pop();
  var cleanDots = numbers.replace('.', '');
  var replaceComma = cleanDots.replace(',', '.');
  return parseFloat(replaceComma);
};